/**
 * Fetch a PDF report for a process and trigger a browser download.
 *
 * Returns a promise that resolves to one of:
 *   { ok: true }
 *   { ok: false, status: 401 }   (unauthorized — caller should redirect to login)
 *   { ok: false, status, error } (other errors)
 *
 * The caller is responsible for the auth flow when status is 401.
 */
export async function downloadPdfReport(processId, authToken) {
    const url = process.env.REACT_APP_API_URL
        + '/processes/' + encodeURIComponent(processId)
        + '/download_pdf_report/';

    let response;
    try {
        response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Token ' + authToken,
            },
        });
    } catch (networkError) {
        return { ok: false, status: 0, error: 'No se pudo conectar con el servidor.' };
    }

    if (response.status === 401) {
        return { ok: false, status: 401, error: 'Sesión expirada.' };
    }

    if (!response.ok) {
        let serverError = null;
        try {
            const data = await response.json();
            serverError = data.error || data.detail;
        } catch (_) { /* no JSON body */ }
        return {
            ok: false,
            status: response.status,
            error: serverError || ('Error HTTP ' + response.status),
        };
    }

    const blob = await response.blob();
    const filename = parseFilename(response.headers.get('Content-Disposition'))
        || 'reporte-' + processId + '.pdf';

    triggerBrowserDownload(blob, filename);

    return { ok: true };
}


function parseFilename(contentDisposition) {
    if (!contentDisposition) return null;
    const match = /filename="?([^"]+)"?/i.exec(contentDisposition);
    return match ? match[1] : null;
}


function triggerBrowserDownload(blob, filename) {
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    // Delay revocation so the browser has time to start the download.
    setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
}
